import React from 'react'
import { Col } from "react-bootstrap"
import "./aboutme.css"
import bannr from "../assets/images/banner.jpg"
import API_ENDPOINT from '../wm.api.service'

function SuggesctionCard({ userdata, isMobile }) {
    return (
        <>
            <Col md={4} xs={9}>
                <a href={`${API_ENDPOINT.redirectURL}/${userdata.username}`} className="no-underline" target="_blank">
                    <div className="border rounded mt-4">
                        <div className="w-full h-28">
                            <img src={userdata.banner ? userdata.banner : bannr} alt="bannr" className="w-full h-full object-cover" />
                            <div className="bg-gray-200 w-20 h-20 rounded-full overflow-hidden border-2 border-solid border-white inline-block relative left-2/4 profCardImg">
                                <img src={userdata.profile_photo} alt="bannr" className="w-full h-full object-cover" />
                            </div>
                        </div>
                        <div className="mt-5 px-4 md:px-3 pb-3 text-center">
                            <div className="text-center">
                                <span className="manpro block font-medium text-lg lg:text-base xl:text-xl text-gray-600">{userdata.full_name}</span>
                                <span className="manpro block font-medium text-sm text-gray-500">@{userdata.username}</span>
                            </div>
                        </div>
                    </div>
                </a>
            </Col>
        </>
    )
}

export default SuggesctionCard
